import { render } from "./MedicationsAdd.vue?vue&type=template&id=1ddd17a7"
import script from "./MedicationsAdd.vue?vue&type=script&lang=js"
export * from "./MedicationsAdd.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/orders/MedicationsAdd.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1ddd17a7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1ddd17a7', __exports__)) {
    console.log('reload')
    api.reload('1ddd17a7', __exports__)
  }
  
  module.hot.accept("./MedicationsAdd.vue?vue&type=template&id=1ddd17a7", () => {
    console.log('re-render')
    api.rerender('1ddd17a7', render)
  })

}


export default __exports__